import { api } from "./api";

const actions = {
	executeWebSocketAction: (data, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/websocket/action`,
					data,
					onSuccess,
					onFailure
				})
			);
		};
	},
	/* Merge X knowledges */
	mergeKnowledges: (assistantID, uuids, code, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/knowledge/merge/${assistantID}`,
					data: {
						uuids,
						code
					},
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure
				})
			);
		};
	},
	/* Start source process for X sources */
	startFAIQPipeline: (sources, steps = [], onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/faiq/api/v1/sources/pipeline`,
					data: {
						sources,
						steps
					},
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure
				})
			);
		};
	},
	/* Get metadatas filters for page chat */
	getMetadatasFilters: onSuccess => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/faiq/api/v1/metadatas/filters`,
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {}
				})
			);
		};
	}
};

export default actions;
